// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Document, Page } from "react-pdf";
import uuid from "react-native-uuid";
import Tooltip from "rc-tooltip";
import { Loader } from "@revvsales/components";

// Internal Imports
import DocumentItems from "../../DocumentItems";
import { DOCUMENTS, LOADING_MSG } from "../../../constants";
import { GlobalUtils } from "../../../utils";
import APPROVE from "../../../assets/Approved.svg";
import ACCEPTED from "../../../assets/Accepted.svg";
import ESIGNED from "../../../assets/eSigned.svg";

// import { deleteDocumentComponentService } from "../../../actions/DocumentActions/services";
// Action Imports
import {
  addEsignBlockData,
  deleteDocumentComponentAction,
  deleteDocSignerSection,
  updateDataForSignatureSection,
  updateAddEsignBlockData,
  updateDocumentClickedComponentID,
} from "../../../actions/DocumentActions/index";
import QuotationActions from "../../../actions/QuotationActions";
import ToolbarActions from "../../../actions/ToolbarActions";

const {
  setSectionDataForActiveSignatureInRightToolPane,
  updateToolPaneData,
} = QuotationActions;
const { updateAddComponentinToolbarAction } = ToolbarActions;
// Destructure
const { ESIGN_EMPTY_PAYLOAD } = DOCUMENTS;
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { readDataFromLocalStorage } = GlobalUtils;
const { DOCUMENT } = LOADING_MSG;

class PdfDocument extends Component {
  state = {
    numPages: "",
    loader: true,
  };

  componentDidMount() {
    const { isLocked } = this.props;
    if (!isLocked) {
      document.addEventListener(
        "click",
        this._handleDocumentViewOutsideClick,
        false,
      );
    } else {
      this.props.updateAddComponentinToolbarAction(null);
      this.props.updateToolPaneData(false, "");
    }
  }

  componentWillUnmount() {
    const { isLocked } = this.props;
    if (!isLocked) {
      document.removeEventListener(
        "click",
        this._handleDocumentViewOutsideClick,
        false,
      );
    } else {
      this.props.updateAddComponentinToolbarAction(null);
      this.props.updateToolPaneData(false, "");
    }
  }

  _handleDocumentViewOutsideClick = () => {
    const { clickedActiveComponentId, clickedActiveComponentType } = this.props;
    if (clickedActiveComponentId) {
      if (clickedActiveComponentType === "Signature") {
        this.props.setSectionDataForActiveSignatureInRightToolPane({});
        this.props.updateDocumentClickedComponentID(null, true, null);
      }
    }
  };

  _addSigner = ({ x, y, pageNo }) => {
    if (this.props.stage === "DRAFT") {
      if (this.props.clickedActiveComponentId) {
        const signData = JSON.parse(JSON.stringify(this.props.signatories));
        const signersData = signData.filter(
          data => data.component_id === this.props.clickedActiveComponentId,
        );
        signersData[0].signers[0].signer_config.point.x = x;
        signersData[0].signers[0].signer_config.point.y = y;
        signersData[0].signers[0].signer_config.point.page_no = pageNo;

        const payload = [
          {
            component_id: this.props.clickedActiveComponentId,
            signers: signersData[0].signers,
          },
        ];
        this.props.updateAddEsignBlockData(payload);
        this.props.addEsignBlockData(this.props.documentID, payload);
      } else {
        const signerData = JSON.parse(JSON.stringify(ESIGN_EMPTY_PAYLOAD));
        signerData.signer_config.point.x = x;
        signerData.signer_config.point.y = y;
        signerData.signer_config.point.page_no = pageNo;
        const payload = [
          {
            component_id: uuid.v4(),
            signers: [signerData],
          },
        ];
        this.props.addEsignBlockData(this.props.documentID, payload);
      }
    }
    // Reset document block cursor offset values
    window.documentBlockCursorOffset = null;
  };

  _getCoordinates = (event, pageNo) => {
    event.preventDefault();
    const box = document.querySelector(
      `div.document-page-wrapper-${pageNo + 1}`,
    );
    const rect = box.getBoundingClientRect();
    const { height, left, top, width } = rect;
    const windowPositionX = event.clientX;
    const windowPositionY = event.clientY;
    const cursorOffset = window.documentBlockCursorOffset;
    const x = `${windowPositionX - left}` - cursorOffset.left;
    const y = `${windowPositionY - top}` - cursorOffset.top;
    let xAxis = x - 3; // Signature block width padding adjustment
    let yAxis = y - 3; // Signature block height padding adjustment

    // Prevent content going out of bound, do the below calc
    const signerBlockData = document.getElementById(
      this.props.clickedActiveComponentId,
    );
    let finalY = 60;
    if (signerBlockData) {
      finalY = signerBlockData.clientHeight;
    }

    // FOR X axis
    if (x < 0) {
      xAxis = 0;
    }
    if (width - x <= 200) {
      xAxis = width - 5 - 200; // Canvas width - 5px signature block padding adjustment - signature block width
    }

    // FOR Y axis
    if (y < 0) {
      yAxis = 0;
    }
    if (height - y <= finalY) {
      yAxis = height - 25 - finalY; // Canvas height - 25px canvas margin bottom handle - signature block height
    }

    this._addSigner({
      x: xAxis,
      y: yAxis,
      pageNo,
    });
  };

  _onDragOver = event => {
    event.preventDefault();
  };

  _onDragStart = event => {
    const dragged = event.target;
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/html", dragged);
    // To get mouse offset for PDF document feature
    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    window.documentBlockCursorOffset = { left: x, top: y };
  };

  _deleteSection = () => {
    const { sectionID } = this.props;
    const component =
      this.props.signatories &&
      this.props.signatories.find(item => item.component_id === sectionID);
    const deleteSigner = [
      {
        component_id: component.component_id,
        ids: component.signers[0].id,
      },
    ];
    this.props.deleteDocSignerSection(
      deleteSigner,
      this.props.documentID,
      component,
    );
  };

  _deleteButton = () => (
    <Tooltip
      placement="top"
      overlay="Delete this block"
      align={{ offset: [0, 3] }}>
      <span
        data-test="documentitems-delete-the-content-btn"
        className="btn-icon"
        id="delete-the-content-btn"
        onMouseDown={() => this._deleteSection(this.props.sectionID)}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "trash-alt"]} />
      </span>
    </Tooltip>
  );

  _decideDocumentItemsView = pdfPageNo => {
    const {
      isLocked,
      addComponent,
      // sectionList,
      deleteSection,
      updateSection,
      draggedFrom,
      draggedSection,
      // sectionTypeList,
      isSharedDocument,
      isDocumentLocked,
      showDocumentDiffView,
      removeActiveComponents,
      removeHighlightSelection,
      updateHoveredSectionId,
      signatories,
    } = this.props;

    let docComponentSectionList = signatories.filter(
      data => data.signers[0].signer_config.point.page_no === pdfPageNo,
    );

    if (isDocumentLocked || isLocked) {
      docComponentSectionList = docComponentSectionList.filter(
        item => item.type !== DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER,
      );
    }
    const listID =
      docComponentSectionList &&
      docComponentSectionList.map(item => item.component_id);

    // const dropAllowed = draggedSection && draggedFrom === "new-component";
    return (
      listID &&
      listID.map(sectionID => {
        const section = this.props.components[sectionID].content;
        const signer = docComponentSectionList.find(
          item => item.component_id === sectionID,
        ).signers[0];

        return (
          <div
            style={{
              position: "absolute",
              left: `${signer.signer_config.point.x}px`,
              top: `${signer.signer_config.point.y}px`,
            }}>
            <DocumentItems
              itemType="doc-component"
              key={sectionID}
              mode="DOCUMENT"
              isLocked={isLocked}
              sectionID={sectionID}
              addComponent={addComponent}
              updateSection={updateSection}
              componentMeta={this.props.componentMeta}
              component={section}
              deleteComponent={this.props.deleteComponent}
              draggedFrom={draggedFrom}
              draggedSection={draggedSection}
              docComponentSectionList={docComponentSectionList}
              removeHighlightSelection={removeHighlightSelection}
              updateHoveredSectionId={updateHoveredSectionId}
              removeActiveComponents={removeActiveComponents}
              showDocumentDiffView={showDocumentDiffView}
              deleteSection={deleteSectionID =>
                deleteSection(
                  deleteSectionID,
                  this.props.sections.find(item => item.id === deleteSectionID),
                )
              }
              isSharedDocument={isSharedDocument}
              isDocumentLocked={isDocumentLocked}
              sectionActionBtnsRef={this.sectionActionBtnsRef}
              customToolbarRef={this.props.customToolbarRef}
              signatureWrapperRef={this.props.signatureWrapperRef}
              setRefsByType={this._setRefsByType}
              pdfPageNo={pdfPageNo}
            />
          </div>
        );
      })
    );
  };

  _documentStatusBand = () => {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const { stage, docRecipientList, acceptorsList } = this.props;
    const signerList = [];
    if (docRecipientList && docRecipientList.length > 0) {
      docRecipientList.map(item =>
        item.recipient_type === "SIGNER" ? signerList.push(item) : null,
      );
    }
    let bandStatus = null;
    if (CURRENT_USER) {
      if (stage === "APPROVED") {
        if (
          this.props.docApprovalStatus &&
          this.props.docApprovalStatus.length > 0
        ) {
          bandStatus = (
            <div className="doc-status-band remove-from-export">
              <img
                src={APPROVE}
                className="doc-imgband-check-wrapper"
                alt="Revv"
              />

              <div>Everyone approved the document</div>
            </div>
          );
        } else {
          bandStatus = (
            <div className="doc-status-band remove-from-export approved-status-band">
              <img
                src={APPROVE}
                className="doc-imgband-check-wrapper"
                alt="Revv"
              />

              <div>
                Document did not trigger any workflow. It is auto-approved
              </div>
            </div>
          );
        }
      } else if (stage === "SENT") {
        if (acceptorsList && acceptorsList.length > 0) {
          if (
            acceptorsList &&
            acceptorsList.find(
              item =>
                item.user &&
                item.user.id === CURRENT_USER.id &&
                item.recipient_type === "ACCEPTOR" &&
                item.accepting_states === "",
            )
          ) {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
                </span>

                <div>Your consent is required on this document</div>
              </div>
            );
          } else {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
                </span>

                <div>Document sent for acceptance</div>
              </div>
            );
          }
        } else if (signerList && signerList.length > 0) {
          if (
            docRecipientList &&
            docRecipientList.find(
              item =>
                item.user &&
                item.user.id === CURRENT_USER.id &&
                item.recipient_type === "SIGNER",
            )
          ) {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
                </span>

                <div>Document requires your consent.</div>
              </div>
            );
          } else {
            bandStatus = (
              <div className="doc-status-warning-band remove-from-export">
                <span className="doc-statusband-check-wrapper">
                  <FontAwesomeIcon icon={["far", "signature"]} />
                </span>

                <div>Document sent for eSignature</div>
              </div>
            );
          }
        }
      } else if (stage === "COMPLETED") {
        if (acceptorsList && acceptorsList.length > 0) {
          bandStatus = (
            <div className="doc-status-band remove-from-export">
              <img
                src={ACCEPTED}
                className="doc-imgband-check-wrapper"
                alt="Revv"
              />
              <div>Everyone accepted the document</div>
            </div>
          );
        } else if (signerList && signerList.length > 0) {
          bandStatus = (
            <div className="doc-esigncompleted-status-band remove-from-export">
              <img
                src={ESIGNED}
                className="doc-esign-imgband-check"
                alt="Revv"
              />

              <div>Everyone signed the document</div>
            </div>
          );
        }
      } else if (stage === "DECLINED") {
        if (acceptorsList && acceptorsList.length > 0) {
          bandStatus = (
            <div className="doc-declined-status-band remove-from-export">
              <span className="doc-statusband-check-wrapper">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>
              <div>Document has been rejected by a receiver</div>
            </div>
          );
        } else if (signerList && signerList.length > 0) {
          bandStatus = (
            <div className="doc-declined-status-band remove-from-export">
              <span className="doc-statusband-check-wrapper">
                <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
              </span>

              <div>Document declined by a signer</div>
            </div>
          );
        }
      } else if (stage === "SENT_FOR_FILLING") {
        bandStatus = (
          <div className="doc-status-warning-band remove-from-export">
            <span className="doc-statusband-check-wrapper">
              <FontAwesomeIcon icon={["far", "exclamation-circle"]} />
            </span>

            <div>Document sent for filling to signers.</div>
          </div>
        );
      }
    }
    return bandStatus;
  };

  render() {
    const signerData = JSON.parse(JSON.stringify(ESIGN_EMPTY_PAYLOAD));
    const pdfUrl =
      process.env.REACT_APP_ENVIRONMENT === "LOCAL"
        ? "http://www.africau.edu/images/default/sample.pdf"
        : this.props.pdfUrl;

    return (
      <div className="document-pdf-wrapper">
        {this.state.loader && <Loader label={DOCUMENT} fullScreen />}
        <div
          style={
            this.props.isPdfDocument
              ? {
                  position: "absolute",
                  left: `${signerData.signer_config.point.x}px`,
                  top: `${signerData.signer_config.point.y}px`,
                }
              : {}
          }
        />
        {this._documentStatusBand()}
        <div className="document-pdf-canvas">
          <Document
            file={pdfUrl}
            options={{
              withCredentials: true,
            }}
            onLoadSuccess={({ numPages }) => {
              this.setState({ numPages, loader: false });
            }}
            renderAnnotationLayer
            renderInteractiveForms>
            {Array.from(new Array(this.state.numPages), (el, index) => (
              <div
                onKeyPress={() => null}
                role="button"
                tabIndex="0"
                onDrop={e => this._getCoordinates(e, index)}
                onDragOver={this._onDragOver}
                onDragStart={this._onDragStart}
                className={`document-page-wrapper-${index + 1}`}>
                <div
                  id="document-page-area"
                  data-test="documentview-document-sections-container">
                  <div>
                    <Page
                      renderTextLayer={false}
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      className="document-pdf-page">
                      <div>{this._decideDocumentItemsView(index)}</div>
                    </Page>
                  </div>
                </div>
              </div>
            ))}
          </Document>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: {
      docNo,
      id: documentID,
      pdfUrl,
      signatories,
      isPdfDocument,
      stage,
      isLocked,
    } = {},
    acceptorsList,
    docRecipientList,
    components,
    clickedActiveComponentId,
    clickedActiveComponentType,
  } = state.DocumentStore;
  const userData =
    signatories && signatories.length > 0 ? signatories[0].signers : null;
  const sectionID =
    (signatories && signatories.length > 0 && signatories[0].component_id) ||
    "";
  return {
    docNo,
    documentID,
    pdfUrl,
    sectionID,
    isPdfDocument,
    signatories,
    userData,
    stage,
    acceptorsList,
    docRecipientList,
    components,
    isLocked,
    clickedActiveComponentId,
    clickedActiveComponentType,
  };
};

const mapDispatchToProps = {
  addEsignBlockData,
  deleteDocumentComponentAction,
  deleteDocSignerSection,
  updateDataForSignatureSection,
  updateAddEsignBlockData,
  setSectionDataForActiveSignatureInRightToolPane,
  updateDocumentClickedComponentID,
  updateAddComponentinToolbarAction,
  updateToolPaneData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PdfDocument);



// WEBPACK FOOTER //
// ./src/components/Document/PdfDocument/index.js